import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format';

import $ from 'jquery'

import axios from 'axios'
import querystring from 'querystring'

import {
    removeProduct
} from '../../modules/cart'

class Cart extends React.Component {

    constructor(props) {
        super(props);
    }

    showQuotation() {
        $(".quotation").fadeIn();
        $(".basket-popup").fadeOut();
        $(".content-container").fadeOut();
        $("html, body").animate({ scrollTop: 0 }, "fast");
    }

    hideBasket() {
        $(".basket-popup").fadeOut();
        if($(".opener").is(":visible") == false){
            $('.opener').fadeIn();
        }
    }

    onDeleteCartItem(key){
        this.props.removeProduct({
            key: key
        });

        const _this = this;

        setTimeout(function () {
            _this.updateSessionCart();
        }, 1000);
    }

    updateSessionCart(){

        const _this = this;

        axios.post(_this.props.config.api_path+'updateSessionCart', querystring.stringify({
            cart: JSON.stringify(this.props.cart.items)
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    render() {

        var cartProductsSum = 0;
        var optionalAttributesSum = 0;

        const _this = this;

        var cartProducts = this.props.cart.items.map(function(element, key) {

            var product_price = parseFloat((element.price * (element.product_type === "dragonfly" ? _this.props.user.price_tier_multiplier_dragonfly : _this.props.user.price_tier_multiplier) * _this.props.user.currency.conversion_factor * (element.product_type === "dragonfly" ? 1 : _this.props.user.currency.tps_factor)) + (element.attribute_price * _this.props.user.currency.conversion_factor)).toFixed(2);

            cartProductsSum+=(product_price* element.quantity);

            return (
                <CartProduct key={"CartItem"+key} cartID={key} qty={element.quantity} price={element.price} attribute_price={element.attribute_price} product_type={element.product_type} prod_number={element.number} opt_attributes={element.optional_attributes_text} onDeleteCartItem={(key) => _this.onDeleteCartItem(key)} user={_this.props.user}/>
            );
        });

        return (
            <div className="basket-popup">
                <div className="logo">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         width="178.049px" height="81.625px" viewBox="0 0 178.049 81.625" enableBackground="new 0 0 178.049 81.625"
                         xmlSpace="preserve">
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <circle fill="#ffffff" cx="88.995" cy="29.963" r="26.931"/>
                                        </g>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M81.669,18.744c2.104-1.377,4.62-2.176,7.325-2.176c2.7,0,5.216,0.798,7.317,2.172"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M83.507,26.501l-5.631-4.011c-1.438,2.135-2.276,4.704-2.276,7.473c0,3.024,1.005,5.818,2.698,8.063"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M83.507,26.501"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M94.451,34.298"/>
                                        </g>
                                        <g>

                                            <path fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" d="
                                            M100.103,22.472c1.447,2.139,2.287,4.716,2.287,7.491c0,3.027-1.006,5.821-2.697,8.065l-5.241-3.73"/>
                                        </g>
                                        <g>

                                            <line fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" x1="88.994" y1="16.567" x2="88.994" y2="43.609"/>
                                        </g>
                                        <g>

                                            <circle fill="none" stroke="#009982" strokeWidth="3.6147" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="2.6131" cx="88.994" cy="29.963" r="20.626"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <g>
                                        <g>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="7.917,75.457 9.994,64.906 20.101,64.906
                                            27.42,70.982 28.615,64.906 36.891,64.906 34.814,75.457 25.226,75.457 17.185,69.279 15.968,75.457 7.917,75.457 					"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="38.897,75.457 40.733,64.906 59.34,64.906
                                            58.888,67.494 47.088,67.494 46.869,68.75 56.424,68.75 55.97,71.353 46.415,71.353 46.174,72.738 58.557,72.738
                                            58.085,75.457 38.897,75.457 					"/>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#ffffff" d="M62.911,65.013h6.703l-0.944,5.079
                                            c-0.138,0.747-0.192,1.283-0.167,1.608c0.032,0.324,0.132,0.598,0.309,0.816c0.204,0.265,0.619,0.471,1.231,0.61
                                            s1.381,0.211,2.3,0.211c0.921,0,1.71-0.071,2.375-0.211c0.657-0.14,1.15-0.346,1.464-0.61c0.26-0.219,0.458-0.492,0.612-0.816
                                            c0.146-0.325,0.291-0.861,0.432-1.608l0.131-0.714l0.812-4.365h6.687l-1.027,5.522c-0.212,1.144-0.529,1.988-0.959,2.534
                                            c-0.429,0.545-1.061,1.007-1.909,1.395c-0.918,0.422-2.139,0.74-3.645,0.951c-1.511,0.213-3.317,0.317-5.416,0.317
                                            c-2.11,0-3.878-0.104-5.304-0.317c-1.427-0.211-2.53-0.529-3.303-0.951c-0.691-0.388-1.151-0.85-1.384-1.395
                                            c-0.227-0.546-0.236-1.391-0.023-2.534l0.202-1.086L62.911,65.013L62.911,65.013z"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="90.532,75.457 92.056,67.482 86.455,67.482
                                            86.925,65.013 104.942,65.013 104.471,67.482 98.87,67.482 97.347,75.457 90.532,75.457 					"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="131.16,75.457 133.095,64.906 141.05,64.906
                                            139.117,75.457 131.16,75.457 					"/>
                                            <polygon fillRule="evenodd" clipRule="evenodd" fill="#ffffff" points="142.867,75.457 145.064,65.013 152.473,65.013
                                            151.475,69.756 161.161,65.013 169.881,65.013 158.66,70.107 168.565,75.457 159.225,75.457 151.262,70.768 150.275,75.457
                                            142.867,75.457 					"/>
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#ffffff" d="M105.548,75.457l1.659-10.443h8.326
                                            c3.256,0,5.522,0.054,6.785,0.161c1.266,0.106,2.347,0.287,3.24,0.538c1.003,0.283,1.755,0.649,2.251,1.09
                                            c0.494,0.443,0.696,0.931,0.612,1.463c-0.128,0.809-0.786,1.466-1.977,1.974c-1.19,0.506-2.865,0.841-5.017,1.007l7.288,4.211
                                            h-9l-6.053-4.088l-0.65,4.088H105.548L105.548,75.457z M113.891,69.949h1.477c1.717,0,2.987-0.104,3.812-0.313
                                            c0.823-0.211,1.27-0.54,1.341-0.985c0.083-0.522-0.226-0.895-0.933-1.116c-0.7-0.223-1.923-0.332-3.666-0.332h-1.596
                                            L113.891,69.949L113.891,69.949z"/>
                                        </g>
                                    </g>
                                </g>
                                <g>
                                    <rect x="171.714" y="65.013" fill="none" width="5.672" height="4.558"/>
                                    <path fill="#ffffff" d="M172.832,64.976c0.188,0,0.37,0.049,0.548,0.145s0.316,0.232,0.416,0.412
                                    c0.1,0.178,0.149,0.364,0.149,0.559c0,0.191-0.05,0.375-0.147,0.553s-0.234,0.314-0.411,0.412s-0.361,0.146-0.555,0.146
                                    c-0.192,0-0.377-0.049-0.554-0.146s-0.314-0.234-0.412-0.412c-0.099-0.178-0.147-0.361-0.147-0.553
                                    c0-0.194,0.05-0.381,0.149-0.559c0.1-0.18,0.238-0.316,0.417-0.412C172.463,65.025,172.646,64.976,172.832,64.976z
                                     M172.832,65.162c-0.156,0-0.309,0.039-0.456,0.119c-0.148,0.08-0.265,0.195-0.348,0.344c-0.084,0.15-0.126,0.305-0.126,0.467
                                    c0,0.16,0.041,0.313,0.124,0.461c0.082,0.146,0.196,0.262,0.344,0.344s0.302,0.123,0.462,0.123c0.161,0,0.314-0.041,0.462-0.123
                                    s0.263-0.197,0.344-0.344c0.082-0.147,0.123-0.301,0.123-0.461c0-0.162-0.042-0.316-0.125-0.467
                                    c-0.083-0.148-0.199-0.264-0.348-0.344S172.987,65.162,172.832,65.162z M172.344,66.707v-1.199h0.412
                                    c0.141,0,0.242,0.012,0.306,0.033c0.063,0.022,0.112,0.062,0.15,0.116c0.037,0.056,0.056,0.114,0.056,0.176
                                    c0,0.087-0.031,0.163-0.094,0.229s-0.146,0.102-0.248,0.109c0.042,0.018,0.076,0.039,0.102,0.063
                                    c0.048,0.047,0.107,0.127,0.177,0.237l0.146,0.235h-0.236l-0.106-0.189c-0.083-0.148-0.151-0.241-0.202-0.279
                                    c-0.035-0.027-0.087-0.041-0.155-0.041h-0.113v0.51H172.344z M172.537,66.032h0.234c0.112,0,0.189-0.017,0.229-0.05
                                    c0.041-0.033,0.062-0.078,0.062-0.133c0-0.035-0.01-0.067-0.029-0.096c-0.02-0.027-0.047-0.049-0.082-0.063
                                    s-0.1-0.021-0.194-0.021h-0.22V66.032z"/>
                                </g>
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </div>
                <div className="slogan">
                    <b>optical</b>CON: <span className="light">Your Cart</span>
                </div>
                <div className="clearler"></div>
                <div className="item-container">
                    <div className="item-heading">Your Items:</div>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                        <tr>
                            <th>Qty:</th>
                            <th>Prod Number:</th>
                            <th>Options:</th>
                            <th className="price">Price:</th>
                            <th>&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        {cartProducts}
                        <tr>
                            <td colSpan="3">Total:</td>
                            {this.props.user.user != null && this.props.user.currency != null &&
                            <td className="price">
                                {this.props.user.currency.symbol} <NumberFormat
                                value={cartProductsSum}
                                displayType={'text'} thousandSeparator={"'"} decimalSeparator={"."}
                                decimalScale={2} fixedDecimalScale={true} />
                            </td>
                            }
                            <td>&nbsp;</td>
                        </tr>
                        </tbody>
                    </table>

                    <div className="row">
                        <div className="button-container col-dt-50 align-left col-mob-100">
                            &nbsp;
                        </div>
                        {/*<div className="button-container col-dt-50 align-left col-mob-100">

                         <button type="button">
                         Download Details for Items
                         </button>

                         </div>*/}

                        { this.props.cart.items != null && this.props.cart.items.length > 0 &&
                        <div className="button-container col-dt-50 align-right col-mob-100">
                            <button type="button" onClick={() => this.showQuotation()}>
                                Start building your Quotation »
                            </button>
                        </div>
                        }

                    </div>

                </div>
                <div className="basket-closer" onClick={() => this.hideBasket()}>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                        <path d="M25.192,25.692c-0.977,0.977-2.56,0.977-3.535,0L6.808,10.843c-0.977-0.977-0.977-2.559,0-3.536l0,0
					c0.977-0.977,2.559-0.977,3.536,0l14.849,14.85C26.169,23.133,26.169,24.716,25.192,25.692L25.192,25.692z"/>
                        <path d="M6.808,25.692c-0.977-0.977-0.977-2.56,0-3.535l14.85-14.85c0.976-0.977,2.559-0.977,3.535,0l0,0
					c0.977,0.977,0.977,2.559,0,3.536L10.343,25.692C9.367,26.669,7.784,26.669,6.808,25.692L6.808,25.692z"/>
                    </svg>
                </div>
            </div>
        );
    }
}

class CartProduct extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cartID: props.cartID
        };
    }

    onDeleteClick() {
        this.props.onDeleteCartItem(this.state.cartID);
    }

    render() {

        return (
            <tr>
                <td>{this.props.qty} Pcs.</td>
                <td>{this.props.prod_number}</td>
                <td>{this.props.opt_attributes}</td>
                {this.props.user.user !== null && this.props.user.currency !== null &&
                <td className="price">
                    {this.props.user.currency.symbol} <NumberFormat
                    value={(this.props.qty * parseFloat((this.props.price * (this.props.product_type === "dragonfly" ? this.props.user.price_tier_multiplier_dragonfly : this.props.user.price_tier_multiplier) * this.props.user.currency.conversion_factor * (this.props.product_type === "dragonfly" ? 1 : this.props.user.currency.tps_factor)) + (this.props.attribute_price * this.props.user.currency.conversion_factor)).toFixed(2))}
                    displayType={'text'} thousandSeparator={"'"} decimalSeparator={"."} decimalScale={2} fixedDecimalScale={true} />
                </td>
                }
                <td>
                    <div onClick={() => this.onDeleteClick()}>
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                            <path d="M25.192,25.692c-0.977,0.977-2.56,0.977-3.535,0L6.808,10.843c-0.977-0.977-0.977-2.559,0-3.536l0,0
										c0.977-0.977,2.559-0.977,3.536,0l14.849,14.85C26.169,23.133,26.169,24.716,25.192,25.692L25.192,25.692z"/>
                            <path d="M6.808,25.692c-0.977-0.977-0.977-2.56,0-3.535l14.85-14.85c0.976-0.977,2.559-0.977,3.535,0l0,0
										c0.977,0.977,0.977,2.559,0,3.536L10.343,25.692C9.367,26.669,7.784,26.669,6.808,25.692L6.808,25.692z"/>
                        </svg>
                    </div>
                </td>
            </tr>
        );
    }
}


const mapStateToProps = state => ({
    routing: state.routing,
    config: state.config,
    user: state.user,
    cart: state.cart
})

const mapDispatchToProps = dispatch => bindActionCreators({
    removeProduct
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Cart)


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/app/cart.js